export const createRaveVideoAsset = (data) => {
    if (!assertRaveVideoAsset(data, "save")) {
        throw new Error("RaveVideoAsset.save failed");
    }
    return data;
};
export function assertRaveVideoAsset(videoAsset, mode = "load") {
    if (!videoAsset || typeof videoAsset !== "object") {
        throw new Error("RaveVideoAsset must be an object");
    }
    return true;
}
export const createRaveVideoAssetConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(videoAsset) {
        if (!assertRaveVideoAsset(videoAsset, "save")) {
            throw new Error("RaveVideoAsset.save failed");
        }
        const { id, ...rest } = videoAsset;
        return rest;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const videoAsset = {
            ...data,
            id: snapshot.id,
        };
        if (!assertRaveVideoAsset(videoAsset)) {
            throw new Error("RaveVideoAsset.load failed");
        }
        return videoAsset;
    },
});
//# sourceMappingURL=RaveVideoAsset.js.map